import { HeroSection } from './HeroSection/HeroSection';
import { CompanyHeroSection } from './CompanyHeroSection/CompanyHeroSection';
import { FeaturesSection } from './FeaturesSection/FeaturesSection';
import { BuildIchra } from './BuildICHRA/index';
import { TurnKey } from './TurnKey/index';
import { IchraSolution } from './IchraSolution/index';
import { WhyWeStarted } from './WhyWeStarted/index';
import { ReadToBuild } from './ReadToBuild/index';
import { Pricing } from './Pricing/index';
import { OurMission } from './OurMission/index';
import { LeaderShipTeam } from './LeaderShipTeam/index';
import { ContactUs } from './ContactUs/index';
import { PlansHero } from './PlansHero/index';
import { PlansSection } from './PlansSection/index';
import { PlansTabsWidget } from './PlansTabsWidget/index';
import { HeroOvalDivider } from './HeroOvalDivider/index';
import { ThankYou } from './ThankYou/index';
import { FoundingTeam } from './FoundingTeam/index';
import { AdvisoryBoard } from './AdvisoryBoard/index';
import { PressAndMedia } from './PressAndMedia/index';
import { PressKit } from './PressKit/index';
import { UseCasesHero } from './UseCasesHero/index';
import { UseCasesOverviewCards } from './UseCasesOverviewCards/index';
import { UseCasesOverviewHero } from './UseCasesOverviewHero/index';
import { UseCasesWhyHow } from './UseCasesWhyHow/index';
import { ExploreOtherUseCases } from './ExploreOtherUseCases/index';
import { TrojanHorseSection } from './TrojanHorseSection/index';
import { SwitchingToPBSection } from './SwitchingToPBSection/index';
import { WhatBrokersAreSaying } from './WhatBrokersAreSaying/index';
import { StrategicComparison } from './StrategicComparison/index';
import { TheDefense } from './TheDefense/index';
import { ThePivotScript } from './ThePivotScript/index';

export type {
    UseCasesHeroProps,
    UseCasesHeroBadge,
    UseCasesHeroImage,
    UseCasesHeroDescriptionType,
} from './UseCasesHero/index';

export type { UseCasesOverviewHeroProps } from './UseCasesOverviewHero/index';

export type { UseCasesOverviewCardsProps } from './UseCasesOverviewCards/index';

export type {
    UseCasesWhyHowProps,
    UseCasesWhyHowPill,
    UseCasesWhyHowPillNavMode,
    UseCasesWhyHowInnerCard,
    UseCasesWhyHowBlock,
} from './UseCasesWhyHow/index';

export type { ExploreOtherUseCasesProps, UseCaseExploreSlug } from './ExploreOtherUseCases/index';

export type {
    TrojanHorseSectionProps,
    TrojanHorseCard,
} from './TrojanHorseSection/index';

export type {
    SwitchingToPBSectionProps,
    SwitchingToPBSectionCard,
} from './SwitchingToPBSection/index';

export type {
    WhatBrokersAreSayingProps,
    WhatBrokersAreSayingSlide,
} from './WhatBrokersAreSaying/index';

export type {
    StrategicComparisonProps,
    StrategicComparisonRow,
} from './StrategicComparison/index';

export type { TheDefenseProps } from './TheDefense/index';

export const Widgets = {
    HeroSection,
    CompanyHeroSection,
    FeaturesSection,
    BuildIchra,
    TurnKey,
    IchraSolution,
    WhyWeStarted,
    ReadToBuild,
    Pricing,
    OurMission,
    LeaderShipTeam,
    ContactUs,
    PlansHero,
    PlansSection,
    PlansTabsWidget,
    HeroOvalDivider,
    ThankYou,
    FoundingTeam,
    AdvisoryBoard,
    PressAndMedia,
    PressKit,
    UseCasesHero,
    UseCasesOverviewHero,
    UseCasesOverviewCards,
    UseCasesWhyHow,
    ExploreOtherUseCases,
    TrojanHorseSection,
    SwitchingToPBSection,
    WhatBrokersAreSaying,
    StrategicComparison,
    TheDefense,
    ThePivotScript,
};
